import React, {useContext, useEffect, useState} from "react";
import {Link} from "react-router-dom";
import AddIcon from "@material-ui/icons/Add";
import {
    Box,
    Button,
    Container,
    FormControl,
    Grid,
    IconButton,
    Input,
    InputAdornment,
    Typography
} from '@deere/fuel-react';
import TeamsList from "./TeamsList";
import {Team} from "./Team";
import {searchListWitMembers} from '../shared/utils';
import {useAuthConfig} from "../shared/helper";
import SearchIcon from "@material-ui/icons/Search";
import {TeamMemberFilter} from "../shared/filter/TeamMemberFilter"
import {SupplierFilter} from "../shared/filter/SupplierFilter";
import {Loading} from "../shared/Loading";
import {UserContext} from "./Main";

export const Teams = ({name}) => {
    let authAxios = useAuthConfig();
    const userInfo = useContext(UserContext);
    const userId = userInfo && userInfo.userId;
    const userFirstName = userInfo && userInfo.firstName;
    const userLastName = userInfo && userInfo.lastName;
    const [teamsList, setTeamsList] = useState(null);
    const [expanded, setExpanded] = React.useState(false);
    const [expandedSupplier, setExpandedSupplier] = React.useState(false);
    const [query, setQuery] = useState("");
    const [searchParam] = useState(["functionalAreaType", "supplierNumber", "supplierName", "fiscalYear", "supplyBaseManger", "combineMembers"]);
    const [searchParamDesc] = useState(["teamMembers"]);
    const [selectedTeamMembers, setSelectedTeamMembers] = useState([]);
    const [selectedSuppliers, setSelectedSuppliers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const getTeamComponent = list => {
        return list.map((item) => {
            return (
                <Team team={item}/>
            );
        });
    }

    const handleUserChange = (event) => {
        setSelectedTeamMembers(event);
        setSelectedSuppliers([]);
        sessionStorage.setItem("selectedSuppliers", JSON.stringify([]));
        sessionStorage.setItem("selectedTeamMembers", JSON.stringify(event));
    }

    const handleSupplierChange = (event) => {
        setSelectedSuppliers(event);
        setSelectedTeamMembers([]);
        sessionStorage.setItem("selectedTeamMembers", JSON.stringify([]));
        sessionStorage.setItem("selectedSuppliers", JSON.stringify(event));
    }

    const getTeams = async (teamMembers, supplierdata) => {
        setIsLoading(true)
        const memberIds = teamMembers ? teamMembers.map(function (data) {
            return data.racfID;
        }) : [];
        const supplierNumbers = supplierdata ? supplierdata.map(function (data) {
            return data.supplierNumber;
        }) : [];
        try {
            const searchData = {
                memberIds: memberIds,
                supplierNumbers: supplierNumbers
            }
            return await authAxios.post(`/teams/search`, searchData);
        } catch (e) {
            console.error(e);
        }
    };

    const processTeamsComponent = (response) => {
        const updatedList = [];
        response.forEach((item) => {
            if (Object.keys(item.teamMembers).length !== 0) {
                let allNames = item.teamMembers.reduce(function (acc, obj) {
                    return acc.concat(obj["name"])
                }, [])
                const searchHelperObj = {combineMembers: allNames.join(";")}
                item = {...item, ...searchHelperObj};
            }
            updatedList.push(item)
        });
        const list = getTeamComponent(updatedList);
        setIsLoading(false)
        setTeamsList(list);
    }

    const handleViewResults = async () => {
        setExpanded(false);
        setExpandedSupplier(false);
        const selectedSuppliersData = sessionStorage["selectedSuppliers"] ? JSON.parse(sessionStorage.getItem("selectedSuppliers")) : selectedSuppliers;
        getTeams(selectedTeamMembers, selectedSuppliersData).then(res => {
            processTeamsComponent(res.data)
        });
    }

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const handleChangeSupplier = (panel) => (event, isExpanded) => {
        setExpandedSupplier(isExpanded ? panel : false);
    };

    const filterTeamList = (items) => {
        return items && items.filter((item) => {
            return searchListWitMembers(item.props.team, searchParam, searchParamDesc, query)
        })
    }

    useEffect(() => {
        const loggedUserInfo = [{racfID: userId, firstName: userFirstName, lastName: userLastName}]
        setSelectedTeamMembers(loggedUserInfo)
        if ((!sessionStorage["selectedTeamMembers"] && !sessionStorage["selectedSuppliers"]) || (sessionStorage["selectedTeamMembers"] && JSON.parse(sessionStorage["selectedTeamMembers"]).length > 0 && !JSON.parse(sessionStorage["selectedTeamMembers"])[0].racfID))
            sessionStorage.setItem("selectedTeamMembers", JSON.stringify(loggedUserInfo));

        const teamMemberData = sessionStorage["selectedTeamMembers"] ? JSON.parse(sessionStorage.getItem("selectedTeamMembers")) : [];
        const supplierData = sessionStorage["selectedSuppliers"] ? JSON.parse(sessionStorage.getItem("selectedSuppliers")) : [];

        getTeams(teamMemberData, supplierData).then(res => {
            processTeamsComponent(res.data)
        })

        return () => {
            setTeamsList(null);
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userInfo]);

    return (
        <React.Fragment>
            <Grid container>
                <Grid item xs={3}>
                    <Typography variant="h1" component="h1" data-testid="PageName">
                        {name}
                    </Typography>
                </Grid>
                <Grid item xs={9}>
                    <Container>
                        <Box display="flex" justifyContent="flex-end">
                            <Link
                                to={{
                                    pathname: "/rating-teams/create-team",
                                }}
                                style={{textDecoration: "none"}}
                            >
                                <Button variant="primary" startIcon={<AddIcon/>}>
                                    Create New
                                </Button>
                            </Link>
                        </Box>
                    </Container>
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs={3}>
                    <Box mt={4}>
                        <Button variant="text-inline" size="large">Clear All</Button>
                    </Box>
                    <Box mt={1}>
                        <div className="jdsn-facet-container">
                            <TeamMemberFilter
                                selectedTeamMembers={selectedTeamMembers}
                                onOptionsChange={(e) => {
                                    handleUserChange(e)
                                }}
                                onExpandClick={handleChange}
                                title={"Team Member"}
                                expanded={expanded}
                            />
                            <SupplierFilter
                                selectedSuppliers={selectedSuppliers}
                                onOptionsChange={(e) => {
                                    handleSupplierChange(e)
                                }}
                                onExpandClick={handleChangeSupplier}
                                title={"Supplier"}
                                expanded={expandedSupplier}
                            />
                            <Box className="fixed-bottom position-sticky view-result">
                                <Button variant="primary" fullWidth={true} size="large" onClick={handleViewResults}>View
                                    Results</Button>
                            </Box>
                        </div>
                    </Box>
                </Grid>
                <Grid item xs={9}>
                    <Container>
                        <Box mt={4}>
                            <FormControl fullWidth>
                                <Input fullWidth placeholder="Filter these results" id="search"
                                       endAdornment={
                                           <InputAdornment position="end">
                                               <IconButton aria-label="search">
                                                   <SearchIcon style={{color: " #367c2b"}}/>
                                               </IconButton>
                                           </InputAdornment>
                                       }
                                       onChange={(e) => setQuery(e.target.value)}/>
                            </FormControl>
                        </Box>
                        <Box mt={4}>
                            {isLoading && (
                                <Loading/>
                            )}
                            {!isLoading && (
                                <TeamsList list={filterTeamList(teamsList)}/>
                            )}
                        </Box>
                    </Container>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}
